module.exports = __webpack_public_path__ + "static/media/Frank Mauck Headshot.e26a46b0.jpeg";